export function header() {
	const headerEl = document.querySelector('.main-header')
	let headerTopOffset = 0

	function updateHeaderClass() {
		const scrollPosition = window.scrollY
		if (scrollPosition > 0 && headerTopOffset === 0) {
			headerEl.classList.replace('main-header--top', 'main-header--not-top')
		} else {
			headerEl.classList.replace('main-header--not-top', 'main-header--top')
		}
	}

	if (document.readyState === 'interactive') updateHeaderClass()

	window.addEventListener('scroll', updateHeaderClass)

}
